/**
 * Identifie le siège / site superviseur.
 * Le champ API est `is_supervising_site` (booléen ou 1).
 */
export function isSupervisingSite(antenne) {
  if (!antenne) return false
  const value = antenne.is_supervising_site ?? antenne.isSupervisingSite
  return value === true || value === 1 || value === '1'
}

export function withoutSupervisingSites(antennes = []) {
  return (antennes || []).filter((a) => !isSupervisingSite(a))
}

/** Antenne 100015 : siège AFEPT. Masqué tant que le CFA n'a pas formation_interne. */
const SIEGE_ANTENNE_ID = 100015

export function isSiegeDispositif(antenne) {
  if (!antenne) return false
  const iriId = String(antenne['@id'] || '').split('/').filter(Boolean).pop()
  const id = Number(antenne.id ?? iriId)
  return id === SIEGE_ANTENNE_ID || isSupervisingSite(antenne)
}

function isSuperviseableAntenne(antenne) {
  const value = antenne?.is_superviseable ?? antenne?.isSuperviseable
  return value === true || value === 1 || value === '1'
}

function isSameAntenne(antenne, userAntenne) {
  if (!userAntenne) return false
  return antenne.id == userAntenne.id || antenne['@id'] === userAntenne['@id']
}

/**
 * Options d'un filtre « dispositif de formation ».
 * Garde les antennes. Ajoute le siège si le CFA a formation_interne.
 * mode « scope » : antenne de l'utilisateur ou antennes supervisables.
 * mode « superviseable » : antennes supervisables.
 * mode « all » : toutes les antennes reçues.
 */
export function filterDispositifs(antennes = [], { formationInterne = false, userAntenne = null, mode = 'scope' } = {}) {
  const interne = !!formationInterne
  return (antennes || []).filter((antenne) => {
    if (!antenne) return false
    if (isSiegeDispositif(antenne)) return interne
    if (mode === 'all') return true
    if (mode === 'superviseable') return isSuperviseableAntenne(antenne)
    return isSameAntenne(antenne, userAntenne) || isSuperviseableAntenne(antenne)
  })
}

export function compareAntennesSupervisingFirst(a, b) {
  const supervisingDiff = Number(isSupervisingSite(b)) - Number(isSupervisingSite(a))
  if (supervisingDiff !== 0) return supervisingDiff
  return (a.name || '').localeCompare(b.name || '', 'fr', { sensitivity: 'base' })
}
